module.exports = __webpack_public_path__ + "img/Contribute.83c396ca.jpg";